<template>
  <div class="card card--start">
    <div class="card__content join join--col">
      <h3>Мои данные</h3>
      <dl class="join__item">
        <div>
          <dt>ФИО: </dt>
          <dd>{{ form.full_name }}</dd>
        </div>
        <div>
          <dt>Пол: </dt>
          <dd>{{ GENDERS.find(g => g.value === form.gender)?.text }}</dd>
        </div>
        <div>
          <dt>Дата рождения: </dt>
          <dd>{{ form.birthdate }}</dd>
        </div>
        <div>
          <dt>Телефон: </dt>
          <dd>{{ form.phone }}</dd>
        </div>
        <div>
          <dt>Уровень образования: </dt>
          <dd>{{ KINDS.find(k => k.value === form.kind)?.text }}</dd>
        </div>
      </dl>
      <div v-if="!readonly">
        <router-link class="btn btn--primary" :to="{ name: 'abiturient.form.edit' }">
          Изменить данные
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { KINDS, GENDERS } from '@shared/config'

defineProps({
  form:     { type: Object, default: () => ({}) },
  readonly: { type: Boolean, default: false },
})
</script>
